import {get} from './http'

export const getVisitsCount = params => get('/logCount/visitsCount',params)



// WEBPACK FOOTER //
// ./src/request/visitors.js